import { ChangeEvent, useEffect, useRef, useState } from "react";
import { failAlert } from "./alert";
import styled from "styled-components";

export const CustomFileInputWrapper = styled.div`
  .nonHover {
    overflow: auto;
    border-width: 2px;
    border-style: dashed;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 100px;
    border-color: ${(props) => (props.$error ? "#dc3545" : "#6c757d")};
  }

  .nonHover .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #6c757d;
    padding: 10px;
  }

  .fileList {
    overflow: auto;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & .fileName {
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: none;
    }
    & .fileName:hover {
      color: #3bb77e;
    }

    & .fileSize {
      margin-left: 6px;
      color: rgb(100 116 139);
    }
  }

  .fileList:hover {
    background-color: rgb(203, 213, 225, 0.3);
  }

  .noFiles {
    border-style: dashed;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .deleteBtn {
    cursor: pointer;
  }
  .deleteBtn:hover {
    color: #dc3545;
  }

  .fileInputHover {
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 100px;
    border-style: dashed;
    border-width: 3px;
    border-radius: 10px;
    border-color: #3bb77e;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3bb77e;
    cursor: pointer;
    background-color: #fff;
  }

  .fileInputLabel {
    height: 100%;
    min-height: 100px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0;
  }

  .fileInputLabel:hover {
    color: #3bb77e;
    background-color: #fff;
    margin: 0;
  }

  .fileImg {
    max-width: 24px;
    font-size: 24px;
    font-weight: 300;
  }
`;

const CustomFileInput = (props) => {
  // 각 항목 클릭시 임시 다운로드
  // handleFiles 로 끌어올림
  const { handleFiles, max, ment, reset, error } = props;
  const [files, setFiles] = useState([]);
  const hoverRef = useRef(null);
  const nonHoverRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
    if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";

    const droppedFiles = Array.from(e.dataTransfer.files);
    const tempArr = [...files, ...droppedFiles];
    if (max && tempArr.length > max) {
      failAlert(`파일은 최대 ${max}개까지 가능합니다.`);
      setFiles(tempArr.slice(0, max));
      return;
    }
    setFiles(tempArr);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    if (hoverRef.current) hoverRef.current.style.visibility = "visible";
    if (nonHoverRef.current) nonHoverRef.current.style.visibility = "hidden";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
    if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
  };

  const onChangeFiles = (e) => {
    const fileList = e.target.files ? Array.from(e.target.files) : [];
    const tempArr = [...files, ...fileList];
    if (max && tempArr.length > max) {
      failAlert(`파일은 최대 ${max}개까지 가능합니다.`);
      setFiles(tempArr.slice(0, max));
      e.target.value = "";
      return;
    }
    setFiles(tempArr);
    e.target.value = "";
  };

  const deleteFile = (i) => {
    const tempArr = [...files];
    tempArr.splice(i, 1);
    setFiles(tempArr);
  };

  const fileTypeCheck = (name) => {
    const key = name.split(".").pop()?.toLowerCase();

    switch (key) {
      case "txt":
        return <img src="/img/fileIcons/txt.png" />;
      case "doc":
        return <img src="/img/fileIcons/doc.png" />;
      case "docx":
        return <img src="/img/fileIcons/docx.png" />;
      case "jpg":
        return <img src="/img/fileIcons/jpg.png" />;
      case "jpeg":
        return <img src="/img/fileIcons/jpeg.png" />;
      case "png":
        return <img src="/img/fileIcons/png.png" />;
      case "gif":
        return <img src="/img/fileIcons/gif.png" />;
      case "mp3":
        return <img src="/img/fileIcons/mp3.png" />;
      case "wav":
        return <img src="/img/fileIcons/wav.png" />;
      case "wmv":
        return <img src="/img/fileIcons/wmv.png" />;
      case "flac":
        return <img src="/img/fileIcons/flac.png" />;
      case "mp4":
        return <img src="/img/fileIcons/mp4.png" />;
      case "avi":
        return <img src="/img/fileIcons/avi.png" />;
      case "mkv":
        return <img src="/img/fileIcons/mkv.png" />;
      case "pdf":
        return <img src="/img/fileIcons/pdf.png" />;
      case "zip":
        return <img src="/img/fileIcons/zip.png" />;
      case "xls":
        return <img src="/img/fileIcons/xls.png" />;
      case "ppt":
        return <img src="/img/fileIcons/ppt.png" />;
      case "pptx":
        return <img src="/img/fileIcons/ppt.png" />;
      default:
        return <img src="/img/fileIcons/file.png" />;
    }
  };

  useEffect(() => {
    if (handleFiles) {
      handleFiles(files);
    }
    if (reset) {
      reset(files);
    }
  }, [files]);

  return (
    <>
      <CustomFileInputWrapper
        className="d-flex flex-colum w-100 position-relative"
        $error={error}
      >
        {files && files.length > 0 ? (
          <div id="nonHover" className="nonHover" onDragOver={handleDragOver}>
            <div className="header">
              <div className="d-flex align-items-center">
                <span className="me-3">첨부파일 {files.length}개</span>
                <span className="">
                  {(
                    files.reduce((acc, cur) => acc + cur.size, 0) / 1024
                  ).toFixed(2)}
                  KB
                </span>
              </div>
              {(!max || files.length < max) && (
                <label
                  role="button"
                  className="d-flex align-items-center text-primary"
                  htmlFor="fileInput"
                >
                  <i className="fi-rs-file-import me-1"></i>
                  파일 추가
                </label>
              )}
            </div>
            {files.map((file, i) => (
              <div key={i} className="fileList">
                <div className="d-flex align-items-center">
                  <span className="me-2 fileImg">
                    {fileTypeCheck(file.name)}
                  </span>
                  <span
                    className="fileName"
                    onClick={() => {
                      const url = URL.createObjectURL(file);
                      const a = document.createElement("a");
                      a.href = url;
                      a.target = "_blank";
                      a.click();
                    }}
                  >
                    {file.name}
                  </span>
                  <span className="fileSize">
                    {"(" + (file.size / 1024).toFixed(2) + "KB)"}
                  </span>
                </div>
                <div className="flex items-center">
                  <span className="deleteBtn" onClick={() => deleteFile(i)}>
                    <i className="fi-rs-cross w-6 h-6" />
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            id="nonHover"
            className="nonHover noFiles"
            style={{ visibility: "visible" }}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <>
              <label
                id="fileInputLabel"
                htmlFor="fileInput"
                className="fileInputLabel"
              >
                <span className="d-flex align-items-center">
                  <i className="fi-rs-file-import me-2"></i>
                  {ment ? ment : "파일을 드래그 하거나 클릭하세요."}
                </span>
                {max && <span className="ms-2">(최대 {max}개)</span>}
              </label>
            </>
          </div>
        )}
        {(!max || files.length < max) && (
          <div
            id="hover"
            className="fileInputHover"
            style={{ visibility: "hidden" }}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            ref={hoverRef}
          >
            파일 추가
          </div>
        )}

        <input
          type="file"
          multiple={!max || max > 1}
          id="fileInput"
          className="visually-hidden"
          onChange={onChangeFiles}
        />
      </CustomFileInputWrapper>
    </>
  );
};
export default CustomFileInput;
